import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { QualityInspection, QualityInspectionCreate, QualityInspectionFilter } from '../data/qualityInspection';

export function createQualityInspectionService(client: AxiosInstance) {
  return createCrudService<QualityInspection, QualityInspectionCreate, QualityInspectionFilter>(
    client,
    '/manufacturing/QualityInspection',
    'id',
  );
}

export type QualityInspectionService = CrudService<QualityInspection, QualityInspectionCreate, QualityInspectionFilter>;
